import React from "react";
import {Button, Carousel} from "antd";


import {
    ArrowBackIosNew,
    ArrowForwardIos,
} from "@mui/icons-material";
import {Link} from "react-router-dom";

import banner01 from '../../../../../assets/images/sliders/banner01.jpg'
import banner_1 from '../../../../../assets/images/sliders/banner1.jpg'
import banner_2 from "../../../../../assets/images/sliders/banner2.jpg";
import banner_3 from "../../../../../assets/images/sliders/banner3.jpeg";
import buisnessCards from "../../../../../assets/images/sliders/Business cards.jpg";
import businessLoan from "../../../../../assets/images/sliders/Business loans.jpg";
import corporateProducts from "../../../../../assets/images/sliders/Corporate products.jpg";
import {BannerMoreIco} from "../../../../../modules/CustomIcons";
import { useTranslation } from "react-i18next";

const banner_list= {
    autoplaySpeed: 7000,
    images : [
        {
            img_url : banner01,
            link_url : 'https://www.bankrespublika.az/az/pages/yasil-iqtisadiyyata',
        },{
            img_url : banner_1,
            link_url : 'https://www.bankrespublika.az/az/pages/mobil-pos-xidmeti',
        },
        {
            img_url : banner_2,
            link_url : 'https://e-edf.gov.az/login/entrepreneur',
        },
        {
            img_url : banner_3,
            link_url : ' https://www.bankrespublika.az/az/senedli-emeliyyatlar',
        },  {
            img_url : buisnessCards,
            link_url : 'https://www.bankrespublika.az/az/non-credit-products/business-cards',
        },  {
            img_url : businessLoan,
            link_url : 'https://www.bankrespublika.az/az/loans-for-corporate/mikro-kredit_411',
        },  {
            img_url : corporateProducts,
            link_url : 'https://www.bankrespublika.az/az/#corporate',
        }
    ]
}

const Banners:React.FC =() => {
    const {t} = useTranslation()
    return (
        <>
            <Carousel
                autoplay={true}
                infinite={true}
                arrows={true}
                autoplaySpeed={banner_list.autoplaySpeed}
                prevArrow={<Button icon={<ArrowBackIosNew />} />}
                nextArrow={<Button icon={<ArrowForwardIos />} />}
                dots={{className : 'right_side_banner_dots'}}
                className='right_side_banner'
                effect="fade"
                easing="ease-in-out"
                speed={2000}
            >

                {
                    banner_list?.images?.map((row, index) => {
                        return (
                            <div key ={index} className={'banner_img_box'}>
                                <img src={row.img_url} height={240} />

                                <a target={'_blank'} href={row.link_url} className={'banner_more_btn'} >
                                    <Button type={'default'} icon={<BannerMoreIco />} >{t("ads.more")}</Button>
                                </a>
                            </div>
                        )
                    })
                }

            </Carousel>
        </>
    )
}

export default Banners;
